import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, switchMap, tap} from 'rxjs';
import {DATABASE_NAME} from 'src/app/config/app.config';
import {LOCAL_DATABASE} from 'src/app/core/enums/storage/local-database.enum';
import {STORE_DATABASE} from 'src/app/core/enums/storage/store-database.enum';
import {IndexedDBRepository} from 'src/app/shared/interface/indexed-db-storage.model';
import {ProductFolderDTO, ProductFolderRepository} from '../../domain/repositories/product-folder.repository';

@Injectable()
export class ProductFolderRepositoryAdapter extends IndexedDBRepository<ProductFolderDTO> implements ProductFolderRepository {
  readonly dbName = DATABASE_NAME;
  readonly instanceName = STORE_DATABASE.session;
  private readonly sessionKey = LOCAL_DATABASE.pinnedFolder;

  private readonly folderId = new BehaviorSubject<ProductFolderDTO | null>(null);

  get(): Observable<ProductFolderDTO | null> {
    return this.getItem(this.sessionKey).pipe(
      tap((data: ProductFolderDTO | null) => {
        this.folderId.next(data)
      }),
      switchMap(() => this.folderId.asObservable()),
    );
  }

  save(payload: ProductFolderDTO): Observable<ProductFolderDTO | null> {
    return this.setItem(this.sessionKey, payload).pipe(
      tap(() => this.folderId.next(payload)),
    );
  }

  delete(): Observable<void> {
    return this.removeItem(this.sessionKey).pipe(
      tap(() => this.folderId.next(null)),
    );
  }
}
